const authThemes = {
  formSection: {
    backgroundColor: 'transparent',
    margin: '0px',
    padding: '0px 25px',
  },
  formContainer: {
    marginTop: 'Opx',
    margin: '10px auto 50px auto',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: '100%',
    backgroundColor: 'transparent',
  },
  section: {
    flex: 1,
    width: '100%',
    padding: '0 20',
  },
  sectionHeader: {
    width: '100%',
    marginBottom: 32,
    color: '#fff',
  },
  sectionHeaderText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: '500',
  },
  sectionFooter: {
    width: '100%',
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 15,
  },
  sectionFooterLink: {
    fontSize: 14,
    color: '#ff9900',
    alignItems: 'baseline',
    textAlign: 'center',
  },
  navBar: {
    marginTop: 35,
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  navButton: {
    marginLeft: 12,
    borderRadius: 4,
  },
  cell: {
    flex: 1,
    width: '50%',
  },
  errorRow: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorRowText: {
    marginLeft: 10,
  },
  photo: {
    width: '100%',
  },
  album: {
    width: '100%',
  },
  button: {
    border: '1px solid transparent',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    borderRadius: '0.25rem',
    color: '#fff',
    // marginRight: '3vmin',
    cursor: 'pointer',
    backgroundColor: '#60fff8b3',
    borderColor: '#60fff8b3',
    boxShadow: '0 0 10px 0 rgba(45, 255, 246, 0.5)',
    letterSpacing: '0.05em',
  },
  buttonDisabled: {
    background: 'linearGradient(27.86deg,#000 -5.93%,#132340 78.79%)',
    alignItems: 'center',
    border: '1px solid #a7b6d1',
    color: 'rgba(167,182,209,.4)',
    padding: 16,
  },
  buttonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
  text: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
  formField: {
    marginBottom: 22,
  },
  input: {
    padding: 16,
    borderWidth: 1,
    borderRadius: '0.25rem',
    borderColor: '#61698f',
    backgroundColor: '#151d3d',
    color: '#d9d9d9',
  },
  inputLabel: {
    marginBottom: 8,
    color: '#fff',
  },
  phoneContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  phoneInput: {
    flex: 2,
    padding: 16,
    borderWidth: 1,
    borderRadius: 3,
    borderColor: '#C4C4C4',
  },
  picker: {
    flex: 1,
    height: 44,
  },
  pickerItem: {
    height: 44,
  },
  a: {
    // color: '#fff',
    // textDecoration: 'underline',
    cursor: 'pointer',
    borderBottom: 'solid 1px #8082a0',
    marginLeft: '10px',
  },
};

export default authThemes;
